import { AccessGuids, ConfigSystemParams } from "../../consts";
import { AuthenticationService } from "../../services/auth.service";
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { CompanySelectEvent } from "../../interfaces/events/event-select-company";
import { ComponentAccessUserService } from "../../services/utelize/system/component-access/component-access-user-service";
import { ConfigSystemService } from "../../services/utelize/system/config-system/config-system-service";
import { DropdownBulkOrdersComponent } from "../../dropdowns/orders-bulk/dropdown-orders-bulk.component"
import { DropdownFinancialReportsComponent } from "../../dropdowns/financial-reports/dropdown-financial-reports.component";
import { environment } from "src/environments/environment";
import { ExceptionsService } from "../../services/utelize/general/exceptions-service";
import { IdAndDescriptionDTO } from "../../interfaces/general/id-description";
import { OurDate } from "../../interfaces/general/our-date";
import { SystemUserDTO } from "../../models/system/user/system-user.dto";

@Component({
  selector: 'app-page-comp-header',
  templateUrl: './page-comp-header.component.html',
  styleUrls: ['./page-comp-header.component.scss']
})

export class PageCompHeaderComponent implements OnInit {
  
  @Input() backButtonTooltip                 : string  | undefined;
  @Input() button0Disabled                   : boolean | undefined;
  @Input() button0Show                       : boolean | undefined;
  @Input() button0Text                       : string  | undefined;
  @Input() button0Tooltip                    : string  | undefined;
  @Input() button1Disabled                   : boolean | undefined;
  @Input() button1Show                       : boolean | undefined;
  @Input() button1Text                       : string  | undefined;
  @Input() button1Tooltip                    : string  | undefined;
  @Input() button2Disabled                   : boolean | undefined;
  @Input() button2Show                       : boolean | undefined;
  @Input() button2Text                       : string  | undefined;
  @Input() button2Tooltip                    : string  | undefined;
  @Input() disableTitleAnimation             : boolean = false;
  @Input() filterDate0                       : OurDate | undefined;
  @Input() filterDate0Format                 : string  | undefined;
  @Input() filterDate0MonthSelector          : boolean | undefined;
  @Input() filterDate0Show                   : boolean | undefined;
  @Input() filterDate0Title                  : string  | undefined;
  @Input() filterDate1                       : OurDate | undefined;
  @Input() filterDate1Format                 : string  | undefined;
  @Input() filterDate1MonthSelector          : boolean | undefined;
  @Input() filterDate1Show                   : boolean | undefined;
  @Input() filterDate1Title                  : string  | undefined;
  @Input() hasFeature                        : string  | undefined;
  @Input() hideCompanyDropdownLabel          : boolean = false;
  @Input() hideHeaderLogo                    : boolean = false;
  @Input() hierarchyFormatting               : boolean | undefined;
  @Input() includeCeasedCompanies            : boolean = false;
  @Input() initialCompanyId                  : number  | undefined;
  @Input() initialReportId                   : number  | undefined;
  @Input() initialTypeLicenceId              : number  | undefined;
  @Input() keyButtonActive                   : boolean = false;
  @Input() keyButtonTooltip                  : string  | undefined;
  @Input() label0Show                        : boolean | undefined;
  @Input() label0Text                        : string  | undefined;
  @Input() refreshButtonDisabled             : boolean = false;
  @Input() refreshButtonTooltip              : string  | undefined;
  @Input() rounded                           : boolean = true;
  @Input() showBackButton                    : boolean = false;
  @Input() showBottomBorder                  : boolean = true;
  @Input() showBulkOrderDropdown             : boolean | undefined;
  @Input() showCancelButton                  : boolean | undefined;
  @Input() showCompanyDropdown               : boolean | undefined;
  @Input() showCompanyDropdownSelectAllOption: boolean = true;
  @Input() showDateSelectorViaIcon           : boolean | undefined;
  @Input() showKeyButton                     : boolean = false;
  @Input() showRefreshButton                 : boolean = false;
  @Input() showReportDropdown                : boolean | undefined;
  @Input() showSpinner                       : boolean | undefined;
  @Input() showTypeLicenceDropdown           : boolean | undefined;
  @Input() switch0IsDisabled                 : boolean | undefined;
  @Input() switch0Show                       : boolean | undefined;
  @Input() switch0Text                       : string  | undefined;
  @Input() switch0Value                      : boolean | undefined;
  @Input() switch1IsDisabled                 : boolean | undefined;
  @Input() switch1Show                       : boolean | undefined;
  @Input() switch1Text                       : string  | undefined;
  @Input() switch1Value                      : boolean | undefined;
  @Input() title                             : string  | undefined;
  @Input() useDashboardStyle                 : boolean = false;
  
  @Output() backButtonClick          : EventEmitter<void               >=new EventEmitter<void               >();
  @Output() bulkOrderDropDownChange  : EventEmitter<string             >=new EventEmitter<string             >();
  @Output() button0Click             : EventEmitter<void               >=new EventEmitter<void               >();
  @Output() button1Click             : EventEmitter<void               >=new EventEmitter<void               >();
  @Output() button2Click             : EventEmitter<void               >=new EventEmitter<void               >();
  @Output() cancelButtonOnClick      : EventEmitter<void               >=new EventEmitter<void               >();
  @Output() companyDropDownChange    : EventEmitter<number             >=new EventEmitter<number             >();
  @Output() companyDropDownChange2   : EventEmitter<CompanySelectEvent >=new EventEmitter<CompanySelectEvent >();
  @Output() filterDate0Change        : EventEmitter<OurDate            >=new EventEmitter<OurDate            >();
  @Output() filterDate1Change        : EventEmitter<OurDate            >=new EventEmitter<OurDate            >();
  @Output() keyButtonClick           : EventEmitter<void               >=new EventEmitter<void               >();
  @Output() refreshButtonClick       : EventEmitter<void               >=new EventEmitter<void               >();
  @Output() reportDropDownChange     : EventEmitter<number             >=new EventEmitter<number             >();
  @Output() showDateSelectorClick    : EventEmitter<void               >=new EventEmitter<void               >();
  @Output() switch0Change            : EventEmitter<void               >=new EventEmitter<void               >();
  @Output() switch1Change            : EventEmitter<void               >=new EventEmitter<void               >();
  @Output() typeLicenceDropDownChange: EventEmitter<IdAndDescriptionDTO>=new EventEmitter<IdAndDescriptionDTO>();
  
  @ViewChild('button0Ref',                        { static: false }) button0Ref!                       : ElementRef;
  @ViewChild('button1Ref',                        { static: false }) button1Ref!                       : ElementRef;
  @ViewChild('button2Ref',                        { static: false }) button2Ref!                       : ElementRef;
  @ViewChild('dropdownBulkOrdersComponent',       { static: false }) dropdownBulkOrdersComponent!      : DropdownBulkOrdersComponent;
  @ViewChild('dropdownFinancialReportsComponent', { static: false }) dropdownFinancialReportsComponent!: DropdownFinancialReportsComponent;
  @ViewChild('switch0Ref',                        { static: false }) switch0Ref!                       : ElementRef;
  @ViewChild('switch1Ref',                        { static: false }) switch1Ref!                       : ElementRef;

  get showDateSelectorViaIconClick() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PageCompHeaderShowDateSelectorViaIconClick, false) &&
                                              this.showDateSelectorViaIcon                                                                                    ; }
  get showHeader                  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowPageHeaders,                            true ); }
  get showTooltips                () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTooltips,                               false); }
  get sureSimLogoGrow             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SureSimLogoGrow,                            false) &&
                                              !this.componentAccessUserService.hasAccessGuid(AccessGuids.AnimationSureSimLogoGrowGuard,                 true ); }
  get titlesUseSureSimBlue        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesUseSureSimBlue,                  false); }

  public curUser             : SystemUserDTO;
  public isPlatformModeInview: boolean=environment.platformModeInview;
  
  constructor(
    private authenticationService     : AuthenticationService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public button0OnClick() {
    try {
      this.button0Click.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public button1OnClick() {
    try {
      this.button1Click.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public button2OnClick() {
    try {
      this.button2Click.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public button0UpdateText(buttonText: string) {
    try {
      if (this.button0Ref) {
        this.button0Ref.nativeElement.textContent=buttonText;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public button1UpdateText(buttonText: string) {
    try {
      if (this.button0Ref) {
        this.button1Ref.nativeElement.textContent=buttonText;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public button2UpdateText(buttonText: string) {
    try {
      if (this.button2Ref) {
        this.button2Ref.nativeElement.textContent=buttonText;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public backButtonOnClick(): void {
    try {
      this.backButtonClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public keyButtonOnClick(): void {
    try {
      this.keyButtonClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshButtonOnClick(): void {
    try {
      this.refreshButtonClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public bulkOrderDropDownOnChange(bulkOrderGuid: string) {
    try {
      this.bulkOrderDropDownChange.emit(bulkOrderGuid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public bulkOrderDropDownRefresh(companyId: number, bulkOrderGuid: string) {
    try {
      this.dropdownBulkOrdersComponent.refresh(companyId,bulkOrderGuid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public cancelButtonClick(): void {
    try {
      this.cancelButtonOnClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyDropDownOnChange(companyID: number) {
    try {
      this.companyDropDownChange.emit(companyID);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyDropDownOnChange2(event: CompanySelectEvent) {
    try {
      this.companyDropDownChange2.emit(event);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public filterDate0OnChange(selectedDate: OurDate) {
    try {
      this.filterDate0Change.emit(selectedDate);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public filterDate1OnChange(selectedDate: OurDate) {
    try {
      this.filterDate1Change.emit(selectedDate);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public reportDropDownOnChange(reportID: number) {
    try {
      this.reportDropDownChange.emit(reportID);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public showDateSelectorOnClick() {
    try {
      this.showDateSelectorClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public switch0OnChange() {
    try {
      this.switch0Change.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public switch0UpdateValue(switchValue: boolean) {
    try {
      if (this.switch0Ref) {
        this.switch0Ref.nativeElement.value=switchValue;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public switch1OnChange() {
    try {
      this.switch1Change.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public switch1UpdateValue(switchValue: boolean) {
    try {
      if (this.switch1Ref) {
        this.switch1Ref.nativeElement.value=switchValue;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public typeLicenceDownOnChange(typeLicence: IdAndDescriptionDTO) {
    try {
      this.typeLicenceDropDownChange.emit(typeLicence);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
